import { z } from 'zod';

export const CrmEventsQuery = z.object({ cityId: z.uuid().optional() });
export const CrmOrganizerHistoryQuery = z.object({
  offset: z.coerce.number().int().nonnegative().default(0),
});
export const CrmEventItemDto = z.object({
  id: z.uuid(),
  title: z.string(),
  startsAt: z.iso.datetime(),
  timeZone: z.string(),
  cityId: z.uuid(),
  cityName: z.string(),
  coverImageUrl: z.string().nullable(),
  status: z.string(),
  organizer: z
    .object({
      userId: z.uuid().nullable(),
      username: z.string().nullable(),
      displayName: z.string(),
    })
    .nullable(),
});
export type CrmEventItemDto = z.infer<typeof CrmEventItemDto>;
export const CrmEventsDto = z.object({ items: z.array(CrmEventItemDto) });
export type CrmEventsDto = z.infer<typeof CrmEventsDto>;
export const CrmOrganizerHistoryDto = z.object({
  organizer: CrmEventItemDto.shape.organizer,
  count: z.number().int().nonnegative(),
  items: z.array(CrmEventItemDto),
  nextOffset: z.number().int().nonnegative().nullable(),
});
export type CrmOrganizerHistoryDto = z.infer<typeof CrmOrganizerHistoryDto>;

export const CrmCityDto = z.object({ id: z.uuid(), name: z.string(), timezone: z.string() });
export type CrmCityDto = z.infer<typeof CrmCityDto>;
export const CrmCitiesDto = z.array(CrmCityDto);
